// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/integrations/direct/cdi/jobs" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";

import { integrationsDirectCdiJobs } from "./constants";
import type { IntegrationsDirectCdiJobsParams, CdiJobsResults } from "./types";

export const getCdiJobs = reactQueryTableFetcherAdapter(
  integrationsDirectCdiJobs,
  (
    signal: AbortSignal,
    { appGroupId, query, groupby, limit = 20, start = 0, sortdir, sortby }: IntegrationsDirectCdiJobsParams
  ): Promise<CdiJobsResults> => {
    return fetch(
      "/integrations/direct/cdi/jobs",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  }
);
